// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3613":"9fd67fb4","7689":"9fd67fb4"}[chunkId] + ".chunk.css";
};